import { Controller } from "@hotwired/stimulus"

// Agency Program Phase 2b (#7048): the deposit form collects a dollar amount
// but the controller/webhook credit in integer cents. This controller mirrors
// the dollars input into a hidden cents field on every keystroke and again on
// submit, so the server always receives a clean cents value derived from the
// displayed dollars — no float rounding surprises from a stray decimal.
export default class extends Controller {
  static targets = ["dollars", "cents"]

  connect() {
    this.syncCents()
  }

  // Converts the dollars input to integer cents. Rounds to the nearest cent to
  // avoid binary-float drift (e.g. 19.99 * 100 === 1998.9999...). A blank or
  // non-numeric value yields an empty cents field, which the server rejects via
  // the amount-range validation.
  syncCents() {
    if (!this.hasCentsTarget || !this.hasDollarsTarget) return

    const dollars = parseFloat(this.dollarsTarget.value)
    if (Number.isNaN(dollars)) {
      this.centsTarget.value = ""
      return
    }

    this.centsTarget.value = String(Math.round(dollars * 100))
  }
}
